import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "./LogoG.jpg";

const generatePDF = (invoice, orderNumber) => {
  const doc = new jsPDF();

  doc.setFontSize(24);
  doc.text("QUOTE", 10, 20);

  doc.setFontSize(10);
  doc.text(`ORDER NUMBER: #${orderNumber}`, 12, 35);

  doc.addImage(logo, "PNG", 160, -5, 50, 50);
  doc.setDrawColor(169, 169, 169);
  doc.setLineWidth(1);
  doc.line(10, 42, 200, 42);

  doc.setFontSize(12);
  doc.setTextColor(0, 0, 0);

  // Table Customer
  autoTable(doc, {
    startY: 45,
    margin: { left: 10 },
    head: [
      [
        {
          content: "CLIENTE",
          colSpan: 2,
          styles: { halign: "center", valign: "middle", lineWidth: 0.1 },
        },
      ],
    ],
    body: [
      ["Nombre", invoice.name],
      ["Empresa", invoice.companyName],
      ["Correo electrónico", invoice.email],
      ["Dirección", invoice.address],
    ],
    tableWidth: 85,
    theme: "grid",
    styles: {
      halign: "center",
      valign: "middle",
      cellPadding: { top: 0.5, right: 5, bottom: 0.5, left: 5 },
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontSize: 10,
      fontStyle: "none",
    },
  });

  let customerFinalY = doc.previousAutoTable.finalY;

  // Table Quote
  autoTable(doc, {
    startY: 45,
    margin: { left: 105 },
    head: [
      [
        {
          content: "DESCRIPCIÓN COTIZACIÓN",
          colSpan: 2,
          styles: { halign: "center", valign: "middle", lineWidth: 0.1 },
        },
      ],
    ],
    body: [
      ["Unidad", invoice.truck],
      ["Origen", invoice.origin],
      ["Destino", invoice.destination],
      ["Distancia (km)", invoice.distance],
      ["Duración (hr)", invoice.transitTime],
    ],
    tableWidth: 85,
    theme: "grid",
    styles: {
      halign: "center",
      valign: "middle",
      cellPadding: { top: 0.5, right: 5, bottom: 0.5, left: 5 },
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontSize: 10,
      fontStyle: "none",
    },
  });

  let total = invoice.rows.reduce((acc, row) => acc + parseFloat(row.price), 0);
  // Table Description
  const lastTableFinalY = doc.previousAutoTable.finalY;
  autoTable(doc, {
    startY: lastTableFinalY + 13 || customerFinalY + 13,
    margin: { left: 10 },
    head: [["DESCRIPCIÓN", "PRECIO"]],
    body: [
      ...invoice.rows.map((row) => [
        row.description,
        "$ " +
          parseFloat(row.price).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }),
      ]),
      [
        {
          content: "TOTAL",
          styles: { fontStyle: "bold", textColor: [0, 0, 0] },
        },
        {
          content:
            "$ " +
            total.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }),
          styles: { fontStyle: "bold", textColor: [0, 0, 0] },
        },
      ],
    ],
    tableWidth: 180,
    theme: "grid",
    styles: {
      halign: "center",
      valign: "middle",
      cellPadding: { top: 0.5, right: 5, bottom: 0.5, left: 5 },
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontSize: 10,
      fontStyle: "none",
      lineWidth: 0.1,
    },
  });

  const lastTableFinalYN = doc.previousAutoTable.finalY;
  autoTable(doc, {
    startY: lastTableFinalYN + 5,
    margin: { left: 10 },
    head: [["NOTAS"]],
    body: [[invoice.notes]],
    tableWidth: 180,
    theme: "grid",
    styles: {
      halign: "left",
      valign: "middle",
      cellPadding: { top: 0.5, right: 5, bottom: 0.5, left: 5 },
    },
    headStyles: {
      halign: "center",
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontSize: 10,
      fontStyle: "none",
      lineWidth: 0.1,
    },
  });

  const lastTableFinalY2 = doc.previousAutoTable.finalY;
  autoTable(doc, {
    startY: lastTableFinalY2 + 5,
    margin: { left: 10 },
    head: [["NOTAS E INSTRUCCIONES ESPECIALES"]],
    body: [
      [
        {
          content:
            "Cotización incluye: Transporte de negocio a negocio, Combustible y permisos,   Servicio de escolta (si aplica), Seguro para las unidades transportadas. \nComunicación: Comunicación abierta y actualizaciones disponibles 24/7. \nCoordinación logística: Coordinación y logística detallada antes de la recolección, Soporte continuo durante el transporte, Asistencia después de la entrega. \nTérminos de pago: La información anterior es una estimación de los servicios/productos descritos.\nEl pago se efectúa antes de la descarga. ",
          styles: { halign: "left", valign: "middle", lineWidth: 0.1 },
        },
      ],
    ],
    tableWidth: 180,
    theme: "grid",
    styles: {
      halign: "center",
      valign: "middle",
      cellPadding: { top: 0.5, right: 5, bottom: 0.5, left: 5 },
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontSize: 10,
      fontStyle: "none",
      lineWidth: 0.1,
    },
  });

  const lastTableFinalY3 = doc.previousAutoTable.finalY;
  autoTable(doc, {
    startY: lastTableFinalY3 + 2,
    margin: { left: 10 },
    head: [
      [
        {
          content: "MÉTODOS DE PAGO",
          colSpan: 2,
          styles: { halign: "center", valign: "middle", lineWidth: 0.1 },
        },
      ],
    ],
    body: [
      [
        {
          content:
            "SI SU PAGO ES A TRAVÉS DE TRANSFERENCIA BANCARIA/ACH O ZELLE, POR FAVOR ASEGÚRESE DE AÑADIR ESTE NÚMERO DE COTIZACIÓN A SUS NOTAS DE REFERENCIA DE PAGO.",
          colSpan: 2,
          styles: { halign: "center", valign: "middle", lineWidth: 0.1 },
        },
      ],

      ["DEPÓSITO DIRECTO Y ACH", "TRANSFERENCIAS BANCARIAS (WIRE) / TRANSF. INTERNACIONALES"],
      [
        {
          content:
            "Global Transit Solutions LLC\nBank: Chase Bank\nAccount Number: 530532616\nRouting: 322271627\n5600 Wilshire blvd 01 Los Angeles, CA 90036",
          styles: { halign: "left", valign: "middle", lineWidth: 0.1 },
        },
        {
          content:
            "Global Transit Solutions LLC\nBank: Chase Bank\nAccount Number: 530532616\nRouting: 021000021\nSwift Code: CHASUS33\n5600 Wilshire blvd 01 Los Angeles, CA 90036",
          styles: { halign: "left", valign: "middle", lineWidth: 0.1 },
        },
      ],
    ],
    tableWidth: 180,
    theme: "grid",
    styles: {
      halign: "center",
      valign: "middle",
      cellPadding: { top: 0.5, right: 5, bottom: 0.5, left: 5 },
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontSize: 10,
      fontStyle: "none",
      lineWidth: 0.1,
    },
  });

  const lastTableFinalY4 = doc.previousAutoTable.finalY;
  autoTable(doc, {
    startY: lastTableFinalY4,
    margin: { left: 10 },
    body: [
      [
        {
          content:
            "Zelle: admin@globaltransitsol.com\nTarjetas de crédito/débito: Aceptamos todas las tarjetas con una tarifa de procesamiento del 4%.",
          styles: { halign: "center", valign: "middle", lineWidth: 0.1 },
        },
      ],
    ],
    tableWidth: 180,
    theme: "grid",
    styles: {
      halign: "center",
      valign: "middle",
      cellPadding: { top: 0.5, right: 5, bottom: 0.5, left: 5 },
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontSize: 12,
      fontStyle: "none",
      lineWidth: 0.1,
    },
  });

  const finalY = doc.autoTable.previous.finalY;

  doc.text(
    "¡Gracias por elegirnos!",
    doc.internal.pageSize.getWidth() / 2,
    finalY + 40,
    {
      align: "center",
    }
  );

  doc.setFillColor(0, 0, 0);
  doc.rect(20, finalY + 45, doc.internal.pageSize.getWidth() - 40, 5, "F");

  doc.save(`quote_${orderNumber}.pdf`);
};

export default generatePDF;
